export default __webpack_public_path__ + "static/media/DistrictConvoy1.a33a77cd.jpg";